import {ErrorStateScheduleEnum} from '../../error-state-schedule.enum';

export enum ClientUsersFormErrorStatesEnum {
    UpdateStatusToDeactivateRestricted = ErrorStateScheduleEnum.ClientUsersFormErrorStatesStartIndex,
    UpdateStatusFailed,
    UpdateDetailsFailed,
    UpdatePhoneFailed
}
